export default __webpack_public_path__ + "static/ai-powered-malware-identification-f92e5df26150835376ea2ac6a3a87740.png";